// eslint-disable-next-line no-use-before-define
import React, { Suspense, useState } from 'react';
import { useQuery } from 'react-query';

import { Badge, Card, Space } from 'antd';

import  './index.less';
import DF from 'DisplayFramework';


import MyTasksTable from '../../pages/Landing/components/MyTasksTable';


import HeaderDropdown from 'components/HeaderDropdown';
import GetLabel from 'DisplayFramework/components/GetLabel';
import {
  GetMyTasks,
} from 'services/workflow';
import ITasks from 'icons/ITasks';

const TaskLinks = () => {
  
  const [countTask, setCountTask] = useState(0);


  const defaultParam = {
    entity: '',
    entityid: 0,
    taskstatus: 'INIT',
    taskid: 0,
    proccode: '',
  };

  const { datatask,  } = useQuery(
    'GetMyTasks',
    () => GetMyTasks(defaultParam).then((res) => {if (datatask) setCountTask(res.list.length);return res.list;}),
    { refetchOnMount: true, refetchInterval: 60000 }
  );

  const menu = (
    <Suspense fallback="Loading">
      <Card style={{ width: '1400px' }}>
            <MyTasksTable
              title={<GetLabel label="ongoingTasks" />}
              isFromLink checkTable={datatask}
            />
      </Card>
    </Suspense>
  );

  
  return (
    <DF.Provider pagcode="welcome">
      <HeaderDropdown overlay={menu} zIndex={8}>
        <span className={`action`}>
          <Space size={24}>
            {/* <ITasks color="#eb2f96" /> */}
            <ITasks color="black" />

            <Badge count={countTask} style={{ backgroundColor: '#52c41a' }}>
              <GetLabel label="tasks" Inspectstyle={{marginBottom:"25px"}}/>
            </Badge>
           
          </Space>
        </span>
      </HeaderDropdown>
    </DF.Provider>
  );
};

export default TaskLinks;
